// ApplicationDetail.jsx
import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";

import Train from "../Assessts/homeImages/aerospace-hover.png";
import defenceImg from "../Assessts/homeImages/ship-hover.jpg";
import aeroplaneImg from "../Assessts/homeImages/antiAircraft-hover.png";
import helicopterImg from "../Assessts/homeImages/helicopter-hover.png";
import warshipImg from "../Assessts/homeImages/submarine-hover.png";
import wartankImg from "../Assessts/homeImages/drone-hover.png";

const applicationDetails = {
  aerospace: {
    title: "AEROSPACE",
    img: Train,
    desc: `Aerospace applications cover aircraft, satellites, and cutting-edge avionics 
that ensure safety and efficiency in air and space missions. They enable 
precise navigation, long-range communication, and advanced propulsion 
systems. This sector supports both defense and commercial advancements.`
  },
  warships: {
    title: "WAR SHIPS",
    img: defenceImg,
    desc: `Warship technologies integrate modern navigation, combat, and surveillance 
systems to safeguard maritime borders. They are equipped with electronic 
warfare and missile defense solutions for strategic dominance. Their 
resilience ensures operational readiness in naval missions.`
  },
  antiaircrafts: {
    title: "ANTI AIRCRAFTS",
    img: aeroplaneImg,
    desc: `Anti-aircraft applications focus on detecting, tracking, and neutralizing 
aerial threats. They combine radar systems, missile launchers, and targeting 
modules for reliable defense. These technologies provide secure protection 
against evolving air combat challenges.`
  },
  military: {
    title: "MILITARY",
    img: helicopterImg,
    desc: `Military applications include helicopters, drones, and mission systems 
engineered for versatile battlefield operations. They enhance mobility, 
intelligence, and situational awareness. Advanced communication tools 
empower forces to operate effectively in real time.`
  },
  submarines: {
    title: "SUB-MARINES",
    img: warshipImg,
    desc: `Submarine technologies are built with stealth, endurance, and advanced 
navigation capabilities. Integrated sonar systems enable detection and 
tracking in deep waters. They play a vital role in underwater defense, 
strategic deterrence, and maritime security.`
  },
  drones: {
    title: "DRONES",
    img: wartankImg,
    desc: `Drone applications provide surveillance, reconnaissance, and tactical 
support for defense as well as civilian needs. Equipped with AI-driven 
modules, they offer precision targeting and real-time data collection. 
Their flexibility makes them key assets in modern operations.`
  },
};

export default function ApplicationDetail() {
  const { id } = useParams();
  const app = applicationDetails[id];
  const [hovered, setHovered] = useState(false);

  if (!app) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Application Not Found</h2>
        <Link to="/" style={{ color: "#0077ff", textDecoration: "none" }}>
          Go Back
        </Link>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        gap: "40px",
        padding: "50px",
        alignItems: "flex-start",
        maxWidth: "1100px",
        margin: "50px auto",
      }}
    >
      {/* Image with hover effect */}
      <img
        src={app.img}
        alt={app.title}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          maxWidth: "400px",
          borderRadius: "12px",
          boxShadow: hovered
            ? "0 8px 24px rgba(27, 6, 100, 0.6)"
            : "0 4px 12px rgba(0,0,0,0.2)",
          transform: hovered ? "translateY(-6px)" : "translateY(0)",
          transition: "all 0.4s ease-in-out",
          cursor: "pointer",
        }}
      />

      {/* Info */}
      <div style={{ flex: 1 }}>
        <h1 style={{ marginBottom: "20px", fontSize: "28px" }}>
          {app.title}
        </h1>
        <p
          style={{
            marginBottom: "30px",
            fontSize: "18px",
            lineHeight: "1.6",
            textAlign: "justify",
          }}
        >
          {app.desc}
        </p>

        <Link
          to="/"
          style={{
            padding: "10px 20px",
            background: "#0077ff",
            color: "#fff",
            textDecoration: "none",
            borderRadius: "6px",
            fontWeight: "500",
            transition: "background 0.3s ease",
          }}
          onMouseOver={(e) => (e.target.style.background = "#0056b3")}
          onMouseOut={(e) => (e.target.style.background = "#0077ff")}
        >
          ← Back to Applications
        </Link>
      </div>
    </div>
  );
}
